import { Box, Container, Grid, Loader, Paper, Title } from '@mantine/core';
import { FC, PropsWithChildren } from 'react';
import { FooterLinks } from 'src/components/FooterLinks';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

type Props = {
  title?: string;
  subtitle?: string;
  isLoading?: boolean;
};

export const AuthLayout: FC<PropsWithChildren<Props>> = ({
  children,
  title,
  subtitle,
  isLoading = false,
}) => (
  <Container fluid className={styles.layout}>
    <Box className={styles.branding}>
      <Icon name="authBackground" className={styles.brandingBackground} />
      <Icon name="logo" />
    </Box>
    <Paper className={styles.wrapper} shadow="lg">
      <Box className={styles.content}>
        <Box className={styles.heading}>
          {title && (
            <>
              <Title ta="center" className={styles.title} order={1}>
                {title}
              </Title>
            </>
          )}

          {subtitle && (
            <Title ta="center" className={styles.subtitle} order={2}>
              {subtitle}
            </Title>
          )}
        </Box>

        {isLoading ? <Loader className={styles.loader} /> : children}
      </Box>

      <Grid>
        <Grid.Col span={6} offset={3}>
          <FooterLinks />
        </Grid.Col>
      </Grid>
    </Paper>
  </Container>
);
